import * as React from 'react';
import { useState } from 'react';
import PrivacyPanel from './PrivacyPanel';
import styles from './index.module.scss';
export const PrivacyPopover = (props) => {
    const { isChecked = true, checkedImgUrl, unCheckedImgUrl, theme } = props;
    const [isShowPop, setPop] = useState(false);
    return (React.createElement("div", { className: styles["privacy"] },
        theme === 'simple' ? (React.createElement("div", { className: styles.simple, onClick: () => {
                setPop(true);
            } },
            React.createElement("img", { src: checkedImgUrl }))) : (React.createElement(React.Fragment, null,
            React.createElement("img", { src: isChecked ? checkedImgUrl : unCheckedImgUrl, onClick: () => {
                    props.setCheckStatus(!isChecked);
                }, alt: "alt" }),
            React.createElement("div", { className: styles['click-container'] },
                React.createElement("div", { className: styles['checkbox'], onClick: () => {
                        props.setCheckStatus(!isChecked);
                    } }),
                React.createElement("div", { className: styles['popover-link'], onClick: () => {
                        setPop(true);
                    } })))),
        isShowPop ? (React.createElement("div", { className: styles["privacy-mask"], onClick: () => setPop(false) },
            React.createElement(PrivacyPanel, { title: props.title, content: props.content, onConfirm: () => {
                    props.setCheckStatus(true);
                    setPop(false);
                } }))) : null));
};
